
    import {computed, ComputedRef,
    defineComponent, reactive, watch, 
    nextTick} from 'vue'
    import {useStore} from "@/store";
    // import {useRoute} from "vue-router";
    import utils from '@/util/index';
    import { Switch, Tabs, Tab } from 'scvant';

    interface State {
        checkModuleList: any;
        checkModuleListOnlyFlew: any;
        isShowTopNav: boolean;
        needListenScroll: boolean;
        currentName: string;
        topValue: number;
        offsetTop: number;
        checkModules: any;
        logoUrl: string;
        channelType: string;
        onlyFlaw: boolean;
        hasWarn: boolean;
        checkItemModules: any;
        currentCode: string;
        tabList: any;
        checkItemMainHeight: any;
        checkItemMainOffsetTop: any;
        showOptions: any;
    }

    export default defineComponent({
        name: "navigation",
        setup() {
            let state: State = reactive({
                checkModuleList: [],
                checkModuleListOnlyFlew: [],
                isShowTopNav: false, // nav
                needListenScroll: true, // 监听滚动
                currentName: '事故检测',
                topValue: 0,
                offsetTop: 0,
                checkModules: [],
                logoUrl: '',
                channelType: '',
                onlyFlaw: false,
                hasWarn: true,
                checkItemModules: {},
                currentCode: 'accident',
                tabList: [],
                checkItemMainHeight: {},
                checkItemMainOffsetTop: {},
                showOptions: false
            })
            // const tabListRef: any = ref(null);
            // const {query} = useRoute();
            const store = useStore()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            let tocOnlyShowFlaw: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            function setScrollNum(){
                let header: any = document.getElementById("entrust");
                let checkItemMain: any = document.getElementById("checkItemMain");
                if (header) {
                    // 这里要得到top的距离和元素自身的高度
                    state.offsetTop = header.offsetTop;
                }
                if (checkItemMain) {
                    state.checkItemMainHeight = checkItemMain.clientHeight;
                    state.checkItemMainOffsetTop = checkItemMain.offsetTop;
                }
            }
            watch(reportData, (data: any) => {
                const { checkModuleList, haveDefect } = data;
                state.hasWarn = haveDefect;
                state.checkModuleList = checkModuleList;
                checkModuleList.forEach(item => {
                    if (item && item.defectCount>0) {
                        state.checkModuleListOnlyFlew.push(item);
                    } else if (item.code === 'ecu') {
                        state.checkModuleListOnlyFlew.push(item);
                    }
                });
                state.checkModuleList = checkModuleList;
                state.tabList = checkModuleList;
            }, {immediate: true, deep: true})
            watch(tocOnlyShowFlaw, (data: any) => {
                state.onlyFlaw = data;
                let tabListD = [];
                if (state.onlyFlaw) {
                    state.tabList = state.checkModuleListOnlyFlew;
                } else {
                    state.tabList = state.checkModuleList
                }
                
            })
            function changeShowFlaw(data) {
                store.dispatch('saveTocOnlyShowFlaw', data);
            }
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            return {
                state,
                // scrollToTop,
                changeShowFlaw,
                setScrollNum,
                getElementToPageTop
            }
        },
        mounted() {
            this.setScrollNum();
            window.addEventListener('scroll', this.scrollToTop);
        },
        computed: {
            
        },
        methods: {
            clickTab(name: string) { // 点击tab切换
                let fileData = this.state.tabList.filter(el => {
                    return el.code === name
                });
                const id: string = fileData[0].code;
                this.state.needListenScroll = false;
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = this.getElementToPageTop(eTopEl);
                utils.scrollTop(window, sTop, topNum - 60, 500);
                setTimeout(() => {
                    this.state.needListenScroll = true;
                }, 300);
                this.state.currentName = name
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
            },
            scrollToTop: utils.debounce(function(this){
                this.setScrollNum();
                if (!this.state.needListenScroll) return;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // const listEl = document.getElementById('checkItemList');
                if (scrollTop >= this.state.checkItemMainOffsetTop && scrollTop <= this.state.checkItemMainHeight + this.state.checkItemMainOffsetTop) {
                    this.state.isShowTopNav = true;
                } else {
                    this.state.isShowTopNav = false;
                }
                if (this.state.tabList && this.state.tabList.length> 0) {
                    this.state.tabList.forEach((item: any) => {
                        const getTopEl: any = document.getElementById(item.code);
                        let getTop = this.getElementToPageTop(getTopEl);
                        if (scrollTop >= getTop - this.state.topValue - 60) {
                            this.state.currentName = item.code;
                        }
                    });
                }
                
                let activeEl: any = document.getElementById(`${this.state.currentName}1`);
                if(activeEl) {
                    activeEl.scrollIntoView({inline: 'center'});
                }
            }, 17),
            changeShowOptions() {
                this.state.showOptions = !this.state.showOptions;
            },
            clickOptions(code, e) {
                this.state.showOptions = false;
                this.clickTab(code);
                let activeEl: any = document.getElementById(`${this.state.currentName}1`);
                if(activeEl) {
                    activeEl.scrollIntoView({inline: 'center'});
                }
            }
        },
        components: {
            // componentTitle,
            [Switch.name]: Switch,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
        },
        unmounted() {
             window.removeEventListener('scroll', this.scrollToTop)
        }
    })
